<script setup>
// Переключатель «звук на устройстве оператора» для телефонных источников
// (UIS / MANGO / МегаФон ВАТС). Включено — софтфон в браузере не поднимается:
// АТС звонит на стационарный/мобильный, а в HelpDesk остаётся карточка «кто
// звонит», история, запись и набор номера (звонок всё равно идёт через АТС).
import { nextTick, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { useAlert } from 'dashboard/composables';
import { isDeviceAudioInbox } from 'dashboard/helper/inbox';
import InboxesAPI from 'dashboard/api/inboxes';
import SettingsToggleSection from 'dashboard/components-next/Settings/SettingsToggleSection.vue';

const props = defineProps({
  inbox: { type: Object, required: true },
});

const { t } = useI18n();
const store = useStore();

const onDevice = ref(isDeviceAudioInbox(props.inbox));
const isSaving = ref(false);

watch(
  () => props.inbox,
  inbox => {
    if (!isSaving.value) onDevice.value = isDeviceAudioInbox(inbox);
  }
);

watch(onDevice, async (value, previous) => {
  if (value === previous || isSaving.value) return;
  isSaving.value = true;
  try {
    await InboxesAPI.setAudioMode(props.inbox.id, value ? 'device' : 'browser');
    await store.dispatch('inboxes/get', props.inbox.id);
    useAlert(t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'));
  } catch (error) {
    onDevice.value = previous;
    // откат сам дёргает этот watch — даём ему отработать, пока isSaving ещё true,
    // иначе упавший запрос уходит повторно по кругу
    await nextTick();
    useAlert(t('INBOX_MGMT.EDIT.API.ERROR_MESSAGE'));
  } finally {
    isSaving.value = false;
  }
});
</script>

<template>
  <SettingsToggleSection
    v-model="onDevice"
    :header="t('INBOX_MGMT.AUDIO_MODE.TITLE')"
    :description="t('INBOX_MGMT.AUDIO_MODE.DESC')"
  />
</template>
